import DashedLineComponent from '../../../../DashedLineComponent';
import AnimatedCircleComponent from '../../../../AnimatedCircleComponent';

import withComponentName from '../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const getLanguageLine = (left, top) => {
  const startLine = {
    left,
    top,
  };
  return `M${startLine.left},${startLine.top} v75 a30,30 0 0 1 -30,30 h-150 a30,30 0 0 0 -30,30 v75`;
};

const BackgroundLanguage = ({ width }) => {
  if (width <= 1120) return null;
  return (
    <>
      <AnimatedCircleComponent
        inSection
        className={Styles.anim_circle}
      />
      <DashedLineComponent
        coords={getLanguageLine(244, 56)}
      />
    </>
  );
};

export default withComponentName(BackgroundLanguage);
